import React, { useEffect, useState } from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import { chakra } from '@chakra-ui/react';

import { DragBoxPreview } from './DragBox';
import { ItemTypes } from './types';
import { ContentBoxPreview } from './ContentDrag';

function getItemStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null,
) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export interface CustomDragLayerProps {}

let instancesCount = 0;

export const DragLayer: React.FC<CustomDragLayerProps> = (props) => {
  const [instanceIndex, setInstanceIndex] = useState(instancesCount);
  const { itemType, isDragging, item, initialOffset, currentOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }));

  function renderItem() {
    switch (itemType) {
      case ItemTypes.DragBox:
        return (
          <DragBoxPreview
            text={item.text}
            boxShadow="xl"
            transform="rotate(-7deg)"
          />
        );
      case ItemTypes.ContentBox:
        return (
          <ContentBoxPreview
            type={item.type}
            src={item.src}
            boxShadow="xl"
            transform="rotate(-7deg)"
          />
        );
      default:
        return null;
    }
  }

  useEffect(() => {
    setInstanceIndex(instancesCount);
    instancesCount += 1;
    return () => {
      instancesCount -= 1;
    };
  }, []);

  if (!isDragging || instanceIndex > 0) {
    return null;
  }
  return (
    <chakra.div
      position="fixed"
      pointerEvents="none"
      zIndex={100}
      left={0}
      top={0}
      w="full"
      h="full"
    >
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </chakra.div>
  );
};
